import React, { Component } from "react";
import styles from "./Item.local.scss";

export default class OrganizationDashboardFetching extends Component {
  render() {
    let items = [];
    for (let i = 0; i < 3; i++) {
      items.push(
        <div
          key={i}
          className={`${styles.element} ${styles.element_dasboard} ${
            styles.gradiant
          }`}
        />
      );
    }
    return items;
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationList/OrganizationDashboardFetching.js